"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.solveUserType = exports.solveAssetOwner = exports.solveIsCommentOwner = exports.default = void 0;

/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
var solveIsCommentOwner = function solveIsCommentOwner(imsData, creator) {
  return imsData.id !== undefined && imsData.id === creator.id || imsData.authId !== undefined && imsData.authId === creator.id;
};

exports.solveIsCommentOwner = solveIsCommentOwner;

var solveAssetOwner = function solveAssetOwner(imsData, assetData) {
  return imsData.id === assetData.ownerId;
};

exports.solveAssetOwner = solveAssetOwner;

var solveUserType = function solveUserType(imsData) {
  if (imsData.token) {
    if (imsData.token.includes('AnonBearer')) {
      return 'guest';
    }

    return 'user';
  }

  return undefined;
};

exports.solveUserType = solveUserType;

var solveIsEditorRole = function solveIsEditorRole(userRole) {
  return userRole === 'editor';
};

var useCommentsDropdown = function useCommentsDropdown(assetData, compactLayout, creator, imsData, isEditing, isReply, isResolved, showActive, userRole // eslint-disable-next-line max-params
) {
  var isCommentOwner = solveIsCommentOwner(imsData, creator);
  var userType = solveUserType(imsData);
  var isAssetOwner = solveAssetOwner(imsData, assetData);
  var isEditorRole = solveIsEditorRole(userRole);
  var isResolveable = !compactLayout && (userType === 'user' || isCommentOwner) && showActive && !isReply;
  var items = {
    resolve: Boolean(isResolveable && !isResolved),
    unresolve: Boolean(isResolveable && isResolved),
    edit: Boolean(isCommentOwner && showActive && !isResolved),
    delete: Boolean(isAssetOwner || isCommentOwner || isEditorRole && !assetData.ownerId)
  };
  var hasMenuItems = Object.values(items).reduce(function (acc, itemBool) {
    return acc || itemBool;
  }, false);
  var isVisible = showActive && !(isEditing || !userType || !hasMenuItems);
  return {
    isVisible: isVisible,
    items: items
  };
};

var _default = useCommentsDropdown;
exports.default = _default;